import React from 'react';

import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import Header from '../../components/Header/Header';
import Title from '../../components/Title/Title';

import useStyles from './Style';

import Layout from '../../layouts/public/Public';

const Apresentacao = () => {
    const classes = useStyles();
    return (
        <Layout title="Apresentação">
            <Header />

            <Container maxWidth="xl" className={classes.container} >
                <Grid container spacing={6} >
                    <Grid item xs={12} sm={12} lg={12} xl={12} >
                        <Title variant="h4">
                            OLIMPÍADA DE PROFESSORES DA OBMEP MIRIM
                        </Title>

                        <Typography className={classes.text} variant="body2">
                            A <span className={classes.bolder}>Olimpíada de Professores da OBMEP Mirim</span> é uma realização do IMPA com apoio da B3 Social, promovida com recursos oriundos 
                            do contrato de gestão firmado pelo IMPA com o Ministério da Ciência, Tecnologia e Inovação (MCTI) e com o Ministério da Educação (MEC).
                        </Typography>

                        <Typography className={classes.text} component={'div'} variant="body2">
                            A 1ª Olimpíada de Professores da OBMEP Mirim tem como objetivos principais:
            
                            <ul className={classes.list}>
                                <li> Aprimorar as habilidades dos professores do Ensino Fundamental I na resolução de questões de natureza olímpica;</li>
                                <li> Estimular a participação dos alunos na OBMEP Mirim por meio da atuação direta de seus professores;</li>
                                <li> Ampliar o engajamento das escolas na OBMEP Mirim, fortalecendo a cultura matemática em suas comunidades;</li>
                                <li> Contribuir para a melhoria da qualidade da educação básica, oferecendo aos professores oportunidades de formação e reconhecimento;</li>
                                <li> Valorizar o papel do docente na construção de uma percepção positiva da matemática, desenvolvendo raciocínio lógico e criatividade;</li>
                                <li> Difundir a cultura matemática em todo o território nacional, a partir de ações que integrem professores, alunos e escolas.</li>
                            </ul>
                        </Typography>

                        <Typography className={classes.text} variant="body2">
                            A 1ª Olimpíada de Professores da OBMEP Mirim é dirigida aos professores do Ensino Fundamental I (1º, 2º, 3º, 4º ou 5º anos), com matrícula ativa em escolas 
                            públicas municipais, estaduais e federais e escolas privadas localizadas no território brasileiro.  
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Layout>
    )
}

export default Apresentacao;